export enum CharacterCounterMethod {
  /** Twitter/X counts all URL's as being 23 characters long. */
  TwitterX = 'twitter_x',
}

export interface CharacterCountOptions {
  /**
   * The number of characters at which exceeding content
   * should be highlighted red.
   */
  limit: number | null
  /**
   * Some content types have unique character counter algorithms which
   * alter the count based on the content.
   *
   * By default, the character counter is accurate to the actual text.
   */
  counterMethod?: CharacterCounterMethod | null
  /**
   * If true, the limit is not enforced and the overlimit
   * decoration is not used.
   */
  isSoftLimit?: boolean
  /**
   * The classname used to style the overlimit decoration.
   */
  overLimitClassName?: string
}

export type CharacterCountStorage = {
  /**
   * The current count of characters in the document.
   */
  characters: number
}
